import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'LIBRARY/Header/SideNavigation/sidenav.css';
import config from 'config';
import axios from 'axios';

const imageExtensions = ['jpeg', 'jpg', 'png'];

class SideNav extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            sidebarData: [],
            searchModule: '',
            searchedByModule: false,
            searchedSidebarData: []
        };
    }

    componentDidMount() {
        if(config.instructorInfo.account == 'faculty') {
            //API CALL TO GET MODULE LIST ARRAY
            axios.get(`${config.RootUrl}/faculty/summary/moduleNavigation.json`).then(res => {
                this.setState({
                    sidebarData: res.data
                });
            });
        }else {
            //API CALL TO GET MODULE LIST ARRAY
            axios.get(`${config.RootUrl}/student/learnerModuleNavigation.json`).then(res => {
                this.setState({
                    sidebarData: res.data
                });
            });
        }
    }
    
    // METHOD TO SEARCH MODULE BY NAME
    searchModuleByName = (e) => {
        this.setState({
            searchModule: e.target.value
        });

        if(e.target.value.length > 0) {
            let searchedSidebarData = this.state.searchedSidebarData;
            searchedSidebarData = [];

            this.state.sidebarData.map(menu => {
                if((menu.title.toLowerCase()).includes(e.target.value.toLowerCase())) {
                    searchedSidebarData.push(menu);
                }
            });

            this.setState({
                searchedSidebarData,
                searchedByModule: true
            });
        }else {
            this.setState({
                searchedSidebarData: [],
                searchedByModule: false
            });
        }
    }
      
    closeNav = () => {
        document.getElementById("mySidenav").style.width = "0";
    }

    getMenuKey = (menu, index) => {
        return `${menu.url || menu.title || 'menu'}-${index}`;
    }

    getMenuIcon = (menu) => {
        return [menu.iconType, menu.iconName === 'right-to-bracket' ? 'sign-in-alt' : menu.iconName];
    }
 
    render() {
        return(
            <div id="mySidenav" className="sidenav">
                <div align="center" className="board">
                    <span onClick={this.closeNav} className="icon-cross">X</span>
                    <br />
                    {
                        imageExtensions.includes(config.userPic.substring(config.userPic.lastIndexOf('.') + 1)) ?
                            <img className="rounded-circle" src={config.userPic} />
                        :
                            <FontAwesomeIcon
                                icon={['fas', 'user-circle']}
                                size="lg"
                                style={{ fontSize: 50 }}
                                color="#fff"
                                data-toggle="dropdown"
                            />
                    }
                    <br />
                    <br />
                    <p>{config.emailId}</p>
                    <br />
                </div>
                <div className="navlinks">
                    <div className="searchMenu">
                        <input
                            type="text"
                            className="form-control searchModuleInput"
                            placeholder='Search by Module Name'
                            value={this.state.searchModule}
                            onChange={(e) => this.searchModuleByName(e)}
                        />
                        <FontAwesomeIcon icon={['fas', 'search']} color='#D3D3D3' style={{ marginLeft: '-30px' }} />
                    </div>
                    {
                        this.state.searchedByModule ?
                            <>
                                    {
                                        this.state.searchedSidebarData.length > 0 ?
                                        this.state.searchedSidebarData.map((menu, index) => {
                                            return(
                                                <a href={config.RootUrl + menu.url} key={this.getMenuKey(menu, index)}>
                                                    <span className="sidenav-icon">
                                                        <FontAwesomeIcon icon={this.getMenuIcon(menu)} />
                                                    </span>
                                                    {menu.title}
                                                </a>
                                            );
                                        })
                                    :
                                        <p style={{ fontSize: 13, color: '#818181', paddingLeft: 10, fontWeight: 'normal', marginTop: 15 }}>No module found as per search text.</p>
                                }
                            </>
                        :
                            this.state.sidebarData.map((menu, index) => {
                                return(
                                    <a href={config.RootUrl + menu.url} key={this.getMenuKey(menu, index)}>
                                        <span className="sidenav-icon">
                                            <FontAwesomeIcon icon={this.getMenuIcon(menu)} />
                                        </span>
                                        {menu.title}
                                    </a>
                                );
                            })
                    }
                    <br></br>
                    <br></br>
                    <br></br>
                </div>
            </div>
        );
    }
}

export default SideNav;
